/**
 * Realtime bootstrap.
 */
import Console from '~/utils/lib/core/console'
import { EVENTS as ACCOUNT_EVENTS, observer as accountObserver } from '~/utils/infra/account/types'
import { useBuzzRealtime } from '~/composables/realtime/useBuzzRealtime'

const console = new Console('plugin:realtime')

let alreadyBound = false

export default defineNuxtPlugin(() => {
  const buzzRealtime = useBuzzRealtime()

  if (alreadyBound)
    return

  alreadyBound = true

  accountObserver.on(
    ACCOUNT_EVENTS.ON_SIGNOUT,
    () => buzzRealtime.forceDisconnect({ clearSubscriptions: true })
      .catch(err => console.warn('realtime signout', err))
  )
  accountObserver.on(
    ACCOUNT_EVENTS.ON_STORE_SESSION_DESTROY,
    () => buzzRealtime.forceDisconnect({ clearSubscriptions: true })
      .catch(err => console.warn('realtime session destroy', err))
  )
})

